import * as t from "io-ts";
import { SearchHits } from "./SearchHits";
import { SearchIndex } from "./SearchIndex";

export const InfoSearch = t.intersection([
  t.type({
    index: t.array(SearchIndex),
    q: t.string,
  }),
  t.partial({
    filter: t.string,
    sort: t.array(t.string),
    offset: t.number,
    limit: t.number,
    total: t.number,
    hits: SearchHits,
  }),
]);

export interface InfoSearch {
  index: Array<SearchIndex>;
  q: string;
  filter?: string;
  sort?: Array<string>;
  offset?: number;
  limit?: number;
  total?: number;
  hits?: SearchHits;
}
